import { ASSET_TYPES } from './assetTypes';

export const NAME = 'segment';

export const SEGMENTS = {
  DRILLING: 'drilling',
  COMPLETION: 'completion',
  INTERVENTION: 'intervention',
};

// DEPRECATED: Use SEGMENTS.INTERVENTION instead
// Kept for backward compatibility
/** @deprecated Use SEGMENTS.INTERVENTION instead */
export const INTERVENTION_SEGMENT = SEGMENTS.INTERVENTION;

/**
 * @deprecated drillout is a special case of legacy core apps
 * and should be migrated to use INTERVENTION segment instead
 */
export const DRILLOUT_SEGMENT = 'drillout';

export const FRAC_FLEET_GROUP = {
  id: 'fracFleet',
  name: 'Frac Fleet',
  type: 'frac_fleet',
};

export const PAD_GROUP = {
  name: 'Pad',
  type: 'pad',
  id: 'padId',
};

export const SEGMENT_TO_ASSET_TYPE = {
  [SEGMENTS.DRILLING]: {
    primaryAsset: {
      assetType: ASSET_TYPES.rig,
    },
    secondaryAsset: {
      assetType: ASSET_TYPES.well,
    },
  },
  [SEGMENTS.COMPLETION]: {
    primaryAsset: {
      assetType: ASSET_TYPES.frac_fleet,
      groups: [PAD_GROUP, FRAC_FLEET_GROUP],
    },
    secondaryAsset: {
      assetType: ASSET_TYPES.pad,
    },
  },
  [SEGMENTS.INTERVENTION]: {
    primaryAsset: {
      assetType: ASSET_TYPES.intervention_unit,
    },
    secondaryAsset: {
      assetType: ASSET_TYPES.well,
    },
  },
  [DRILLOUT_SEGMENT]: {
    primaryAsset: {
      assetType: ASSET_TYPES.drillout_unit,
    },
    secondaryAsset: {
      assetType: ASSET_TYPES.well,
    },
  },
};

// NOTE:  SEGMENT_DICT is used for UI segment selectors.
// Only include segments that should appear in user-facing segment pickers.
// Intervention is behind feature flag.
export const SEGMENT_DICT = [
  {
    name: SEGMENTS.DRILLING,
    title: 'Drilling',
  },
  {
    name: SEGMENTS.COMPLETION,
    title: 'Completion',
  },
  // NOTE: Intervention is NOT included by default
  // It is added dynamically in corva-web-frontend based on feature flags
];

export const SEGMENT_LIST = SEGMENT_DICT.map(segment => segment.name);

export const DEFAULT_SEGMENT = SEGMENTS.DRILLING;
